<template>
  <div class="NewsCenterDetails " style="align-self: center;">
      <!-- 标题 -->
    <div class="flex-all-center mt-76">
      <p class="titletext">
        {{ $t('newsCenterDetails6.text1') }}
      </p>
    </div>
    <!-- 标题下图标 -->
    <div class="timeandaddress flex-all-center">
      <div class="mr-6"><img src="../../assets/images/time_icon.png" class="iconimg "></div>
      <div class="mr-38">{{ $t('newsCenterDetails6.text2') }}</div>
      <div class="mr-6"><img src="../../assets/images/postion_icon.png" class="iconimg"></div>
      <div>{{ $t('newsCenterDetails6.text3') }}</div>
    </div>

    <!-- 正文 -->
    <div class="main">
        <div class="maincontent">
        <p>{{ $t('newsCenterDetails6.text4') }}</p>
          <div class="textlayout">
            <img class="picimg" src="../../assets/images/NewsCenterDetails6_pic1.png" >
            <img class="picimg" src="../../assets/images/NewsCenterDetails6_pic2.png" >
            <img class="picimg" src="../../assets/images/NewsCenterDetails6_pic3.png" >
          </div>
        </div>
    </div>
    <!-- 底部 -->
    <div class="footer"></div>
</div>
</template>

<script>
export default {
  name: "newscenterdetails6",
  components: {
    // Tabbar,
  },
  data() {
    return {
    };
  },
  computed: {},
  created() {
    this.getfont();
  },
  methods: {
    // 查询当前根元素字体大小 默认16px
    getfont()
    {
      const fontstyle = window.getComputedStyle(document.documentElement);
      this.rootFontsize = fontstyle.fontSize;
      console.log('字体大小', this.rootFontsize);
    }
  },

};
</script>

<style lang="scss" scoped>
.NewsCenterDetails
{
    color: #000;
    width: 100%;
}

.titletext
{
  font-family: "OPPO-B";
  max-width: 990px;
  line-height: 60px;
  font-size: 42px;
  text-align: center;
}
.main
{
  display: flex;
  justify-content: center;
  margin-top: 40px;
}

.textlayout
{
  display: flex;
  align-items: center;
  justify-content: center;
}

.maincontent
{
  max-width: 990px;
   text-indent: 32px;
   text-align:justify;
   width: 100%;
   line-height: 32px;
   p{
    font-family:"OPPO-R";
    font-size: 16px;
   }
   .maintitie
   {
    text-align: center;
    font-family: "OPPO-B";
    font-size: 28px;
    margin-top: 40px;
    margin-bottom: 40px;
   }
}

.timeandaddress
{
    color: #909399;
    margin-top: 37px;
    font-family: "OPPO-R";
    font-size: 16px;
}

.iconimg
{
    width: 17px;
    height: auto;
    position:relative;
    top: 2px;
}

// 图片
.picimg
{
    width: 284px;
    height: auto;
    margin-top: 40px;
    margin-bottom: 40px;
    margin-left: 20px;
}

.footer
{
  margin-top: 120px;
}

@media (max-width: 768px) {
.titletext
{
  width: 90%;
}
.textlayout
{
  display: flex;
  flex-direction: column;
  margin-top: 20px;
}

.maincontent
{
   text-indent: 32px;
   font-family: "OPPO-R";
   font-size: 17px;
   line-height: 32px;
   width: 90%;

   p{
    font-family:"OPPO-R";
    font-size: 16px;
    
   }
   .maintitie
   {
    text-align: center;
    font-family: "OPPO-B";
    font-size: 28px;
    margin-top: 40px;
   }
}

.picimg
{
    width: 90%;
    height: auto;
    margin-top: 29px;
    margin-bottom: 29px;
    margin-left: 0px;
}

.footer
{
  margin-top: 40px;
}
}
</style>